//import 'es6-promise';
import "@babel/polyfill";
import Vue from 'vue'
import VueTranslate from 'vue-translate-plugin';
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpotify, faApple, faInstagram, faFacebook, faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faSpinner, faUserSecret, faLink, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMeta from 'vue-meta'


// CONFIGURE OUR FONT AWESOME INSTALL.
library.add(faSpinner, faUserSecret, faLink, faDownload, faSpotify, faApple, faInstagram, faFacebook, faFacebookF, faTwitter)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Use Vue Translate
Vue.use(VueTranslate);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
